// extracted by mini-css-extract-plugin
export default {"container":"Hero_2_container__1t27l","heading":"Hero_2_heading__gg-55","notes":"Hero_2_notes__SvWSG"};